import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../@core/auth/jwt/jwtService";

const companyId = process.env.REACT_APP_COMPANY_ID;

export const getMe = createAsyncThunk("root/getMe", async () => {
  const response = await axiosInstance.request({
    url: `/users/me`,
    method: "get",
  });
  return { data: response.data };
});

export const userSlice = createSlice({
  name: "root",
  initialState: {
    list: false,
    abilityList: [],
    reload: false,
  },
  reducers: {
    setEventList: (state, action) => {
      state.eventsArray = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMe.fulfilled, (state, action) => {
        state.list = action.payload.data;
        const auxArray = [];
        const { roles } = action.payload.data;
        let admin = false;
        roles.forEach((element) => {
          if (element.name === "Admin") {
            auxArray.push({ action: "Manage", subject: "All" });
            admin = true;
          } else if (!admin) {
            element?.permissions.forEach((e) => {
              const aux = e.name.split(".");
              auxArray.push({ action: aux[2], subject: aux[1] });
            });
          }
        });
        auxArray.push({ action: "Read", subject: "ok" });
        localStorage.setItem("profile", JSON.stringify(action.payload.data));
        localStorage.setItem("abilityList", JSON.stringify(auxArray));
        state.abilityList = auxArray;
      })
      .addCase(getMe.pending, (state, action) => {});
  },
});

export default userSlice.reducer;
